import React from 'react';
import {View } from 'react-native';

export default function StepperComponent({activeStepCount} : {activeStepCount : any}) {
  const steps=[{ label: 'When' }, { label: 'Facility' }, { label: 'Information' }, { label: 'Material' }];
  return (
    <View>
      <div style={{ position: 'relative', margin: 20 }}>
      {/* Background line */}
      <div style={{
        position: 'absolute',
        top: 14,
        left: 6,
        width: "calc(100% - 20px)",
        height: 3,
        backgroundColor: '#e5e5e5',
        zIndex: 0,
      }} />

      {/* Filled progress line */}
      <div style={{
        position: 'absolute',
        top: 14,
        left: 6,
        height: 3,
        backgroundColor: '#4e3e71',
        width: `${(activeStepCount / (steps.length - 1)) * 98}%`,
        zIndex: 1,
        transition: 'width 0.3s ease',
      }} />

      {/* Step circles + labels */}
      <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative', zIndex: 2 }}>
        {steps.map((step, index) => (
          <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              backgroundColor: index <= activeStepCount ? '#4e3e71' : '#e0e0e0',
              color: '#fff',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 2,
            }}>
            </div>
            <span style={{
              marginTop: 8,
              fontWeight: 500,
              fontSize: "0.875rem",
              textAlign: 'center',
            }}>
              {step.label}
            </span>
          </div>
        ))}
      </div>
    </div>
    </View>
  )
};


